import React, { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { TokenProvider } from './features/authentication/hooks/useToken';
import { ToastContainer } from 'react-toastify';

import useToken from './features/authentication/hooks/useToken';
import Layout from './pages/layout';
const Login = lazy(() => import(`./pages/account/Login/index.jsx`));
import EnvironmentList from './pages/account/environmentList';
import Home from './pages/home/home';
import ForgotPassword from './pages/account/forgotPassword';
import ResetPass from './pages/account/resetpassword';
import ProtectedRoute from './ProtectedRoute';
import CustomerRoutes from './routes/customer.route';
import ProtectedInventoryRoutes from './routes/inventory.protected.route';
import CommissionsRoutes from './routes/commissions.protected.route';
import SettingsProtectedRoutes from './routes/settings.protected.route';
import CustomerProtectedRoutes from './routes/customer.protected.route';
import ReportsProtectedRoutes from './routes/reports.protected.route';
import OrderProtectedRoutes from './routes/order.protected.route';
import TokenRefreshModal from './components/token-refresh-modal';
const KYCAdminReview = React.lazy(() => import('./pages/admin/kyc/KYCAdminReview'));

import 'react-toastify/dist/ReactToastify.css';
import i18n from './util/language/i18n';
import { CustomThemeProvider } from './contexts/ThemeContext';
import { SettingsProvider } from './providers/settings.provider';
import { AllowByFlag } from './components/permission.js';

function App() {
  const { token, setToken, clearToken } = useToken();
  const apiToken = localStorage.getItem('apiToken');
  let userRole = '';

  if (apiToken) {
    userRole = JSON.parse(apiToken).userRole;
  }

  useEffect(() => {
    const code = sessionStorage.getItem('languageCode');
    if (code) i18n.changeLanguage(code);
  }, []);

  switch (window.location.pathname) {
    case '/account/forgotPassword':
      return (
        <>
          <ForgotPassword /> <ToastContainer />
        </>
      );
    case '/account/resetpassword':
      return <ResetPass />;
    case '/account/environments':
      return <EnvironmentList setToken={setToken} clearToken={clearToken} />;
  }

  if (!token) {
    return (
      <SettingsProvider>
        <Login setToken={setToken} />
        <ToastContainer />
      </SettingsProvider>
    );
  }

  if (!token.environmentId) {
    return <EnvironmentList setToken={setToken} clearToken={clearToken} />;
  }

  return (
    <CustomThemeProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <TokenProvider clearToken={clearToken}>
          <SettingsProvider>
            <Suspense fallback={<div>Loading...</div>}>
              <Routes>
                <Route path='/' element={<Layout clearToken={clearToken} />}>
                  <Route index element={<Home />} />

                  {CustomerRoutes.map((route, i) => (
                    <Route
                      key={`${route.path}-${i}`}
                      path={route.path}
                      element={route.element}
                    />
                  ))}

                  <Route element={<ProtectedRoute />}>
                    <Route path='inventory'>
                      {ProtectedInventoryRoutes.map((route, i) => (
                        <Route
                          key={`${route.path}-${i}`}
                          path={route.path}
                          element={route.element}
                        />
                      ))}
                    </Route>
                    <Route path='commissions'>
                      {CommissionsRoutes.map((route, i) => (
                        <Route
                          key={`${route.path}-${i}`}
                          path={route.path}
                          element={route.element}
                        />
                      ))}
                    </Route>
                    <Route path='settings'>
                      {SettingsProtectedRoutes.map((route, i) => (
                        <Route
                          key={`${route.path}-${i}`}
                          path={route.path}
                          element={route.element}
                        />
                      ))}
                    </Route>
                    {CustomerProtectedRoutes.map((route, i) => (
                      <Route
                        key={`${route.path}-${i}`}
                        path={route.path}
                        element={route.element}
                      />
                    ))}
                    {ReportsProtectedRoutes.map((route, i) => (
                      <Route
                        key={`${route.path}-${i}`}
                        path={route.path}
                        element={route.element}
                      />
                    ))}

                    {OrderProtectedRoutes.map((route, i) => (
                      <Route
                        key={`${route.path}-${i}`}
                        path={route.path}
                        element={
                          <AllowByFlag flagKey='SEARCH_ORDER_PAGE'>
                            {route.element}
                          </AllowByFlag>
                        }
                      />
                    ))}
                  </Route>
                </Route>
              </Routes>
            </Suspense>

            <ToastContainer />
            {/* Wrap TokenRefreshModal in a React Portal to isolate it from other components */}
            <React.Suspense fallback={null}>
              <TokenRefreshModal />
            </React.Suspense>
          </SettingsProvider>
        </TokenProvider>
      </BrowserRouter>
    </CustomThemeProvider>
  );
}

export default App;
